export default {
  // Main Hero Section
  title_1: 'International Property Valuation Platform',
  title_2: 'Find Properties Below Market Price',
  lead_1: 'Valuation, forecasting, and comparison powered by AI — all in one place',
  lead_2: 'Modern algorithms: linear regression, random forest, neural network',
  lead_3: 'For investors, developers, agencies, and property sellers',
  login_btn: 'Login',

  // Hero titles for internal pages
  title_property: 'Property Detail',
  title_properties: 'Property Listings',
  title_developer: 'Developer Profile',
  title_developers: 'All Developers',
  title_agency: 'Agency Profile',
  title_agencies: 'Real Estate Agencies',
  title_news: 'News & Insights',
  title_news_item: 'News Detail',
  title_residential_complex: 'Residential Complex',
  title_district: 'District Information',
  title_statistics: 'Market Statistics',
  title_about: 'About Estimator24',

  // Breadcrumbs
  breadcrumbs: {
    home: 'Home',
    properties: 'All Properties',
    developers: 'Developers',
    agencies: 'Agencies',
    news: 'News',
    statistics: 'Statistics',
    about: 'About'
  }
}
